import React from 'react';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, Box } from '@material-ui/core';

import useStyles from './ProviderInputComponents.style';
import { styled } from '@mui/material';

const AppSelect = ({ id, label, value, onChange, items,multiple, helperText, ...rest }) => {
  const classes = useStyles();

  return (
    <FormControl variant="outlined" {...rest} className={classes.select}>
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <Select
        multiple={multiple && multiple}
        value={value}
        onChange={onChange}
        label={label}
        inputProps={{
          name: id,
          id: id,
        }}
      >
        {items && items.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
      </Select>
      <FormHelperText style={{color:'red'}}>
        {helperText}
      </FormHelperText>
    </FormControl>
  )
}
const InputBoxes = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "30px",
  marginTop: "20px",
}));
const RadioInput = styled(Box)(({ theme, selected }) => ({
  width: "200px",
  height: "50px",
  borderRadius: "25px",
  backgroundColor: selected ? "#1AA29D" : "",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  color: selected ? "#ffffff" : "inherit",
  "@media screen and (max-width:600px)": {
      width: "150px",
      height: "50px",
  },
  "@media screen and (max-width:400px)": {
      width: "100px",
      height: "50px",
  },
  "@media screen and (min-width:1800px)": {
      width: "200px",
      height: "50px",
  },
}));

const SelectRadioInput = (props) => {
  return (
      <InputBoxes style={{justifyContent : props.justifyCenter ? 'center' : null}} >
          {props.elements.map((val, i) => (
              <RadioInput
                  key={i}
                  selected={props.value === val} // Highlight if selected
                  style={{
                    border: props.value === val ? "none" : "2px solid #1AA29D", // Show outline when not selected
                    backgroundColor: props.value === val ? "#1AA29D" : "transparent", // Change background color when selected
                    color: props.value === val ? "#ffffff" : "#1AA29D", // Change text color when selected
                  }}
                  onClick={() => {
                      props.setValue(val); // Update the value
                      props.clearValues && props.clearValues.map((val) => {
                        val("")
                      })
                       // Log the selected value
                      props.clearValues && props.clearValues.forEach((clearVal) => clearVal(""));
                  }}
              >
                  <span>{val}</span>
              </RadioInput>
          ))}
      </InputBoxes>
  );
};

export { AppSelect, SelectRadioInput };
